export function downloadImage(dataUri: string) {
  const a = document.createElement("a");

  a.setAttribute("download", "quests.png");
  a.setAttribute("href", dataUri);
  a.click();
  a.remove();
}
